/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-observers, ember/require-tagless-components */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { classNameBindings, classNames } from '@ember-decorators/component';
import { observes } from '@ember-decorators/object';

@classNames('file-picker')
@classNameBindings('empty:is-empty')
export default class FilePicker extends Component {
  @service
  uppy;

  dropPrompt = 'Drop here or %{browse}';
  clickPrompt = 'browse';
  // fileTypes restricts what can be picked. `null` rather than `[]` means "no
  // restriction": Uppy guards with `if (allowedFileTypes)`, and an empty array
  // is truthy, so `[].some(...)` is false for every file and nothing at all can
  // be picked.
  fileTypes = null;

  @tracked
  uppyInstance;

  @observes('file')
  watchFile() {
    if (isEmpty(this.file)) {
      this.uppyInstance.cancelAll();
    }
  }

  didInsertElement() {
    super.didInsertElement(...arguments);
    this.uppyInstance = this.uppy.initFilePickerUppy(
      null,
      this.fileTypes,
      this.elementId,
      this.dropPrompt,
      this.clickPrompt,
      this.onChange,
    );
  }
}
